import { render, staticRenderFns } from "./System.vue?vue&type=template&id=5517d2e8&scoped=true&"
import script from "./System.vue?vue&type=script&lang=js&"
export * from "./System.vue?vue&type=script&lang=js&"
import style0 from "./System.vue?vue&type=style&index=0&id=5517d2e8&lang=scss&scoped=true&"
import style1 from "./System.vue?vue&type=style&index=1&id=5517d2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517d2e8",
  null
  
)

/* custom blocks */
import block0 from "./System.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports